import { module } from 'angular';
import jsonEditorDirective from './json-editor.directive';
import './json-editor.scss';

export default module('app')
	.directive('ngJsoneditor', jsonEditorDirective)
	.name;
